import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { DependentFeaturesByKey } from '@common/common.constant';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    public router: Router) {}

  public static isLoggedIn(): boolean {
    return !!sessionStorage.getItem('session-token');
  }

  public static getToken(): string {
    return sessionStorage.getItem('session-token');
  }

  public static userInfo(): any {
    const userInfo = JSON.parse(sessionStorage.getItem('user-info'));
    return userInfo;
  }

  public static userFeatures(){
    const userInfo = this.userInfo();
    const features = userInfo.feature;
    const featureMap = {};
    if(features && features.length > 0){
      for(const f of features){
        const fname =f.feature.featurename;
        featureMap[fname] = fname;
      }
    }
    return featureMap;
  }

  public login(userInfo: any) {
    sessionStorage.setItem('session-token', userInfo.sessionToken);
    sessionStorage.setItem('user-info', JSON.stringify(userInfo));
    this.router.navigate(['/home']);
  }

  public logout() {
    sessionStorage.removeItem('session-token');
    this.router.navigate(['/']);
  }

  public static isAccess(feature: string): boolean{
    const features = AuthService.userFeatures();
    const keys = Object.keys(features) ||[];
    let isAccess = !!features[feature];
    if(keys.length === 0){
      return true;
    }

    if(DependentFeaturesByKey[feature]){
       const _features= Object.getOwnPropertyNames(DependentFeaturesByKey[feature]);
      for(const f of _features){
        if( !!features[f]){
          isAccess = true;
          break;
        }
      }
    }
    return isAccess;
  }
}
